// ============================================================
//  CONFIGURACIÓN DEL BACKEND
//  Se controla con la variable de entorno REACT_APP_API_URL:
//    .env             -> desarrollo
//    .env.production  -> build de producción
//  Si no está definida, usa el backend de producción.
//
//  Multi-tenant: si la URL actual es /<slug>/..., las peticiones
//  van a /backend/<slug>/... (el .htaccess lo resuelve al tenant).
//
//  IMPORTANTE: baseURL se exporta como un objeto con toString()
//  dinámico para que re-evalúe el slug del tenant en CADA acceso.
//  Así, la navegación SPA entre slugs (/maria/ -> /tienda-enamorate/)
//  sin recargar la página nunca apunta al backend del tenant anterior.
//  Los usos `${baseURL}/archivo.php` siguen funcionando igual.
// ============================================================
import { getTenantSlug } from './paths';

const base = process.env.REACT_APP_API_URL || 'https://shop.solutiontechvp.com/backend';

const baseURL = {
    toString() {
        const slug = getTenantSlug();
        return slug ? `${base}/${slug}` : base;
    },
};

export default baseURL;